import { createContext, ReactNode, useContext, Dispatch } from 'react';

import { State } from '../../../types/tour';

import { initialState } from './GetStarted.state';

import {
  goPrev,
  goNext,
  setComplete,
  showModal,
  hideModal,
  goTo,
} from './GetStarted.actions';

type Props = {
  goPrev: () => void;
  goNext: () => void;
  goTo: (index: number) => void;
  setComplete: (stepIndex: number, parentIndex: number) => void;
  showModal: (title: string, content: string) => void;
  hideModal: () => void;
  state: State;
};

type ProviderProps = {
  children: ReactNode | undefined;
  state: State;
  dispatch: Dispatch<any>;
};

const GetStartedContext = createContext<Props>({
  goPrev: () => null,
  goNext: () => null,
  goTo: () => null,
  setComplete: () => null,
  showModal: () => null,
  hideModal: () => null,
  state: initialState,
});

export const GetStartedProvider = ({
  children,
  state,
  dispatch,
}: ProviderProps) => {
  return (
    <GetStartedContext.Provider
      value={{
        showModal: (title: string, content: string) =>
          dispatch(showModal(title, content)),
        goPrev: () => dispatch(goPrev()),
        goNext: () => dispatch(goNext()),
        goTo: (index) => {
          dispatch(goTo(index));
        },
        setComplete: (stepIndex: number, parentIndex: number) =>
          dispatch(setComplete(stepIndex, parentIndex)),
        hideModal: () => dispatch(hideModal()),
        state: state || initialState,
      }}
    >
      {children}
    </GetStartedContext.Provider>
  );
};

export const useGetStartedContext = () => useContext(GetStartedContext);
